/* eslint-disable react/require-default-props */

import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SplitFactory } from '@splitsoftware/splitio-browserjs';

import SPLIT_FEATURES from './features';

export const SplitContext = createContext({
  loading: false,
  splits: {},
});

const { SPLIT_TOKEN } = process.env;

const SplitContextProvider = ({ children }) => {
  const [contextValue, setContextValue] = useState({
    splits: {},
    loading: true,
  });

  useEffect(() => {
    const userKey = 'gifting';
    const factory = SplitFactory({
      core: {
        authorizationKey: SPLIT_TOKEN,
        key: userKey,
      },
    });
    const client = factory.client();
    const featureList = Object.values(SPLIT_FEATURES);

    /* istanbul ignore next */
    client.on(client.Event.SDK_READY, () => {
      const treatments = client.getTreatmentsWithConfig(featureList);

      setContextValue({
        splits: treatments,
        loading: false,
      });
    });
  }, []);

  return <SplitContext.Provider value={contextValue}>{children}</SplitContext.Provider>;
};

SplitContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SplitContextProvider;

export const SplitConsumer = SplitContext.Consumer;
